/** 方案缩略图的输出长边（像素）。渲染尺寸由它乘以超采样倍数得出 */
export const COMPRESS_SIZE = 1024;
